import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import main_menu_item01 from '../../asset/img/main_menu_item01.svg';
import main_menu_item02 from '../../asset/img/main_menu_item02.svg';
import main_menu_item03 from '../../asset/img/main_menu_item03.svg';
import main_menu_item04 from '../../asset/img/main_menu_item04.svg';
import main_menu_item05 from '../../asset/img/main_menu_item05.svg';

import { MainMenuBannerFill, MainMenuBannerHug } from '../../asset/styled/component/MainMenuBanner';
import IframeViewer from '../../components/common/IframeViewer';
import ScheduleScreen from './Schedule';
import { getMobileOS } from '../../common/Util';
import AiAssistantBanner from './AiAssistantBanner';

const MenuCollection = () => {
  const { myInfo } = useSelector(state => state.myInfo);
  const htmComCd = myInfo?.htmComCd || '';
  const isWoowahan = htmComCd?.trim() == 'woowahan' || htmComCd?.trim() == 'rose';
  const { t } = useTranslation('main');
  const menuLsit = [
    {
      //추가서류 접수
      title: t('menu1Title'),
      // description: t('menu1Description'),
      icon: 'pig',
      link:
        'https://yearend-addon-web.himgt.net/addBoard/main?key=' +
        sStorage.getItem('sessionId') +
        '&alias=' +
        sStorage.getItem('htmAlias'),
      img: main_menu_item01,
      imgAlt: '추가서류 접수',
    },
    {
      //PDF다운로드
      title: t('menu2Title'),
      description: t('menu2Description'),
      icon: 'pig',
      link_android: 'https://play.google.com/store/apps/details?id=kr.go.nts.android',
      link_ios:
        'https://apps.apple.com/kr/app/%EC%97%B0%EB%A7%90%EC%A0%95%EC%82%B0-2021%EB%85%84/id495157796',

      img: main_menu_item02,
      imgAlt: 'PDF다운로드',
    },
    {
      //종합안내
      title: t('menu3Title'),
      description: t('menu3Description'),
      icon: 'pig',
      link: 'https://www.nts.go.kr/nts/cm/cntnts/cntntsView.do?mi=6645&cntntsId=238938',
      img: main_menu_item03,
      imgAlt: '종합안내',
    },
    {
      //연말정산 일정
      title: t('menu4Title'),
      icon: 'pig',
      link: '/tax-notification',
      img: main_menu_item04,
      imgAlt: '연말정산 일정',
    },

    {
      //자주묻는 질문
      title: t('menu5Title'),
      icon: 'pig',
      link:
        'https://yearend-addon-web.himgt.net/faq?key=' +
        sStorage.getItem('sessionId') +
        '&alias=' +
        sStorage.getItem('htmAlias'),
      img: main_menu_item05,
      imgAlt: '자주묻는 질문',
    },
  ];
  const { resultData } = useSelector(state => state.resultQuery);
  const [iframeUrl, setIframeUrl] = useState('');
  const [scheduleOpen, setScheduleOpen] = useState(false);

  const handleScheduleOpen = () => {
    setScheduleOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleScheduleClose = () => {
    setScheduleOpen(false);
    document.body.style.overflow = 'auto';
  };

  // 컴포넌트 언마운트 시 스크롤 복원
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleOpenStore = (type, link) => {
    try {
      // 앱에서 실행 중인 경우
      if (window?.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'OPEN_URL', // 메시지 타입 수정
            url: link,
          }),
        );
        return;
      }

      // 웹브라우저에서 실행 중인 경우
      window.open(link, '_blank');
    } catch (error) {
      console.error('스토어 열기 실패:', error);
      // 실패 시 기본적으로 브라우저에서 열기 시도
      window.open(link, '_blank');
    }
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '8px' }}>
      <div className="displayFlex">
        {/* 추가서류접수 */}
        {resultData.htmViewMagam == '1' && (
          <MainMenuBannerFill
            {...menuLsit[0]}
            style={{ height: 'auto' }}
            onClick={() => setIframeUrl(menuLsit[0].link)}
          />
        )}
      </div>
      <div className="displayFlex" style={{ gap: '8px' }}>
        {/* PDF다운 */}
        <MainMenuBannerFill
          {...menuLsit[1]}
          onClick={() => {
            const os = getMobileOS();
            const link = os === 'ios' ? menuLsit[1].link_ios : menuLsit[1].link_android;
            if (link) {
              handleOpenStore('OPEN_STORE', link);
            }
          }}
        />
        {/* 종합안내 */}
        <MainMenuBannerHug
          {...menuLsit[2]}
          onClick={() => {
            handleOpenStore('OPEN_URL', menuLsit[2].link);
          }}
        />
      </div>
      <div className="displayFlex" style={{ gap: '8px' }}>
        {/* 연말정산 일정 */}
        <MainMenuBannerHug {...menuLsit[3]} onClick={handleScheduleOpen} />
        {/* 자주묻는 질문 */}
        {!isWoowahan && (
          <MainMenuBannerHug {...menuLsit[4]} onClick={() => setIframeUrl(menuLsit[4].link)} />
        )}
        {/* ai 연말정산 세법 도우미  */}
        <AiAssistantBanner />
      </div>

      <IframeViewer
        isOpen={iframeUrl != ''}
        onClose={() => setIframeUrl('')}
        file={iframeUrl}
        style={{ padding: '0px' }}
      />
      {scheduleOpen && <ScheduleScreen isOpen={scheduleOpen} onClose={handleScheduleClose} />}
    </div>
  );
};

export default MenuCollection;
